import React from 'react';
import { ITEMTYPE } from '../../../../../../../Constants/ItemType.Constants';
import settingsParams from '../../../../../../../settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import { getFileIcon } from '../../../../../../Shared/FileAndFolderIcon/getFileIcon';
import { getFolderIcon } from '../../../../../../Shared/FileAndFolderIcon/getFolderIcon';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import { getAppSettings } from '../../../../../../Services/AppSettings.service';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { ENABLE_NEW_THUMBNAIL_SKINS_FO_FILE_SHARE_PANELS } from '../../../../../../../experiments';
import {
  FileShareFill,
  FileShareLabel,
  FileShareLine,
} from '@wix/design-system-illustrations';
import { FILE_ICON_STYLE } from '../../../../../../../Constants/Display.Constants';

const ItemNameIcon = (props: any) => {
  const [, AppSettings]: any = useObservable(getAppSettings());
  const { experiments } = useExperiments();
  const isThumbnailWdsEnabled = experiments.enabled(ENABLE_NEW_THUMBNAIL_SKINS_FO_FILE_SHARE_PANELS);
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';
  const { item } = props;
  const settings = useSettings();
  const fileIconStyle: string = settings.get(settingsParams.fileIconStyle);

  if (isThumbnailWdsEnabled) {
    if (ITEMTYPE.FOLDER in item) {
      return <>{getFolderIcon(fileIconStyle, isMobile)}</>;
    }
    const wdsW = isMobile ? 24 : 40;
    const wdsH = isMobile ? 24 : 44;
    const wdsClip = {
      width: wdsW,
      height: wdsH,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    } as const;
    if (fileIconStyle === FILE_ICON_STYLE.LABEL_ICON) {
      return (
        <span style={wdsClip}>
          <FileShareLabel />
        </span>
      );
    }
    if (fileIconStyle === FILE_ICON_STYLE.LINE_ICON) {
      return (
        <span style={wdsClip}>
          <FileShareLine />
        </span>
      );
    }
    return (
      <span style={wdsClip}>
        <FileShareFill />
      </span>
    );
  }

  return (
    <>
      {ITEMTYPE.FILE in item
        ? getFileIcon(
            item?.fileFields?.extension?.toUpperCase(),
            fileIconStyle,
            isMobile,
          )
        : ITEMTYPE.FOLDER in item
        ? getFolderIcon(fileIconStyle, isMobile)
        : null}
    </>
  );
};

export default ItemNameIcon;
